module.exports = __webpack_public_path__ + "img/profile-container.c85c3405.png";